<app-custom-modal customTitle="Emparejar tablet" (closeFunction)="closeFormFunction()" (acceptFunction)="acceptFormFunction()">

    @if(!code){
    <div class="space-y-4">
        @if(offices.length !== 1){
        <p class="text-xs text-gray-500">
            Elige la oficina a la que pertenecerá la tablet. Solo podrá recibir documentos de firma de esa oficina.
        </p>

        <custom-select label="Oficina" placeholder="SELECCIONAR OFICINA..." [formControlItem]="officeControl"
            [options]="offices" bindValue="id" bindLabel="name">
        </custom-select>
        } @else {
        <p class="text-xs text-gray-500">
            La tablet pertenecerá a la oficina <span class="font-semibold">{{ offices[0].name }}</span> y solo podrá recibir documentos de firma de esa oficina.
        </p>
        }

        <button type="button" (click)="generateCode()" [disabled]="generating"
            class="w-full px-4 py-2.5 bg-indigo-600 text-white text-xs font-semibold uppercase tracking-wider rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            {{ generating ? 'Generando…' : 'Generar código' }}
        </button>
    </div>
    } @else {
    <div class="text-center space-y-3 py-4">
        <p class="text-xs text-gray-500">Introduce este código en la pantalla de la tablet (<span class="font-mono">/tablet-sign</span>)</p>
        <p class="text-4xl font-mono font-bold tracking-[0.3em] text-indigo-600">{{ code }}</p>
        <p class="text-xs text-gray-400">
            @if(remainingSeconds > 0){ Caduca en {{ remainingLabel }} } @else { Código caducado, genera uno nuevo }
        </p>
    </div>
    }

</app-custom-modal>
